import { object } from 'valibot'

import { stringToNumber } from '@/libs/valibot'

export const partnerParamsSchema = object({
  partnerId: stringToNumber()
})
